
import {Component, Prop, Vue} from 'vue-property-decorator'
import {IPartner} from "@/entities";
import {VNode} from "vue";

@Component
export default class PartnersSectionItem extends Vue {

  @Prop() readonly data!: IPartner

  render(createElement: any) {
    const link = this.data.link;
    const src = this.data.file;
    const name = this.data.name;
    let child: VNode | Object = src ? {
      tag: 'img',
      data: {
        attrs: {
          src: src,
          alt: name
        },
        class: 'col partner px-0'
      }
    } : {
      tag: 'p',
      text: name,
      data: {
        class: 'lg strong txt-center partner'
      }
    };
    child = {
      ...child,
      isRootInsert: false,
      isComment: false
    }
    let attributes: Object = {
      title: this.data.name
    };
    if (link) {
      attributes = {
        ...attributes,
        class: 'partner-link',
        href: this.$options.filters?.link(link),
        target: '_blank'
      }
    }
    return createElement(link ? 'a' : 'div', {
      attrs: attributes
    }, [child]);
  }

}
